import { Box, Button, Modal, Typography } from '@tempmee/react';
import { OutlineDocumentTextIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { getStateName } from '~/utils/UsStates';

export interface IOneMoreStepPopupProps {
  open: boolean;
  /** Office state — accepts the BE abbreviation ("TX") or full name; the
   *  popup always renders the full name when known. */
  state: string;
  /** Fired when the user clicks "Review Worker Type". */
  onReview: () => void;
}

// Skip Modal.Header/Modal.Body/Modal.Footer: the DS subcomponents inject
// neutral-200 dividers + a built-in close button, neither of which the
// Figma has. Rendering content as bare children gives us a clean panel.
export const OneMoreStepPopup = ({ open, state, onReview }: IOneMoreStepPopupProps) => {
  const displayState = getStateName(state) ?? state;

  return (
    <Modal
      open={open}
      // Required prop — popup is non-dismissable; closeOnOverlayClick/Escape are off too.
      onClose={() => undefined}
      closeOnOverlayClick={false}
      closeOnEscape={false}
      size="lg"
      data-testid="one-more-step-popup"
    >
      <Box style={{ padding: '48px 40px', textAlign: 'center' }}>
        <Typography
          as="h2"
          bold
          color={colors.neutral[600]}
          textAlign="center"
          style={{ fontSize: 18, margin: 0, marginBottom: 20 }}
        >
          One More Step for Your State
        </Typography>
        <Typography
          size="body_large"
          color={colors.neutral[500]}
          textAlign="center"
          style={{ lineHeight: 1.5, marginBottom: 28 }}
        >
          Since your office is located in{' '}
          <Typography as="span" bold color={colors.neutral[500]}>
            {displayState}
          </Typography>
          , you’ll need to select a worker type to continue. Please review the information
          carefully and choose the option that applies to your office to finish setting up your
          account.
        </Typography>
        <Button
          type="button"
          variant="primary"
          size="lg"
          LeadingIcon={<OutlineDocumentTextIcon size={24} />}
          onClick={onReview}
        >
          Review Worker Type
        </Button>
      </Box>
    </Modal>
  );
};
